import { toast } from "react-toastify";
import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface CloudeStorageStatisticsState {
  CloudeStorageStatistics: {
    load: boolean;
    data: [];
  };
}

export const CloudeStorageStatisticsSlice = createSlice({
  name: "CloudeStorageStatistics",
  initialState: {
    CloudeStorageStatistics: {
      load: false,
      data: [],
    },
  } as CloudeStorageStatisticsState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchCloudeStorageStatistics.pending, (state: CloudeStorageStatisticsState) => {
        state.CloudeStorageStatistics.load = true;
      })
      .addCase(fetchCloudeStorageStatistics.fulfilled, (state: CloudeStorageStatisticsState, action: any) => {
        state.CloudeStorageStatistics.data = action.payload;
        state.CloudeStorageStatistics.load = false;
      })
      .addCase(fetchCloudeStorageStatistics.rejected, (state: CloudeStorageStatisticsState) => {
        state.CloudeStorageStatistics.load = false;
      })
  },
});

export default CloudeStorageStatisticsSlice.reducer;

export const fetchCloudeStorageStatistics = createAsyncThunk(
  "CloudeStorageStatistics/fetchCloudeStorageStatistics",
  async (param: { apiParam: { tpi_firm_id: any, warehouse_id: any, company_type: any } }) => {
    try {
        const { data } = await DataServer.post("api/postCalculateStorage" , {
            warehouse_id: param.apiParam.warehouse_id,
            tpi_firm_id: param.apiParam.tpi_firm_id,
            company_type: param.apiParam.company_type
        });
        return data.data;
    } catch (error) {
    }
  }
);